var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserBardh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.776,
    height: 12.533,
    viewBox: "0 0 15.776 12.533",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "how_to_reg_FILL1_wght400_GRAD0_opsz48",
    d: "M14.911,21.433a.588.588,0,0,1-.22-.04.61.61,0,0,1-.2-.14l-1.982-1.982a.595.595,0,1,1,.841-.841l1.562,1.562,3.844-3.844a.595.595,0,1,1,.841.841l-4.264,4.264a.61.61,0,0,1-.2.14.588.588,0,0,1-.22.04Zm-4.5-6.527a2.88,2.88,0,0,1-3-3,2.88,2.88,0,0,1,3-3,2.88,2.88,0,0,1,3,3,2.88,2.88,0,0,1-3,3ZM4.6,21.353a.582.582,0,0,1-.6-.6V19.471a2.4,2.4,0,0,1,.34-1.251,2.163,2.163,0,0,1,1.021-.871A14.966,14.966,0,0,1,8,16.428a10.542,10.542,0,0,1,2.4-.28,11.524,11.524,0,0,1,1.231.07,8.947,8.947,0,0,1,1.331.25L11.288,18.15a1.234,1.234,0,0,0,0,1.7l1.5,1.5Z",
    transform: "translate(-4 -8.9)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBardh);
export default __webpack_public_path__ + "static/media/User_bardh.de95d78ab900fe592a18f5c81f3d95a8.svg";
export { ForwardRef as ReactComponent };